import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AUTO_LOG_CATEGORY_FOR_LIB, AutoLog } from '../../common/public-api';
import {
  AUTHENTICATION_SERVICE,
  AuthenticationService,
} from '../services/authentication.service';

/**
 * Authorization guard
 *
 * @export
 * @class AuthGuard
 * @implements {CanActivate}
 */
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private _router: Router,
    @Inject(AUTHENTICATION_SERVICE)
    private _authenticationService: AuthenticationService
  ) {
    //
  }

  @AutoLog(AUTO_LOG_CATEGORY_FOR_LIB)
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (
      this._authenticationService.isAuthenticated &&
      this._authenticationService.checkIdTokenExpiration() === false
    ) {
      return of(true);
    }
    const routeState =
      this._router.getCurrentNavigation()?.extras?.state?.['routeState'];
    this._router.navigate(['/login'], {
      queryParams: { redirectPath: state.url, state: routeState },
    });
    return of(false);
  }
}
